module.exports = __webpack_public_path__ + "images/bannerEN-8a73103f9d2318ee51eff80905eaa870.png";